module.exports = [
	{
		"category": "Blacks",
		"colors": [
			{
				"name": "Black 4%",
				"var": "@_black04",
				"hex": "rgba(0,0,0,.04)"
			},
			{
				"name": "Black 6%",
				"var": "@_black06",
				"hex": "rgba(0,0,0,.06)"
			},
			{
				"name": "Black 8%",
				"var": "@_black08",
				"hex": "rgba(0,0,0,.08)"
			},
			{
				"name": "Black 12%",
				"var": "@_black12",
				"hex": "rgba(0,0,0,.12)"
			},
			{
				"name": "Black 26%",
				"var": "@_black26",
				"hex": "rgba(0,0,0,.26)"
			},
			{
				"name": "Black 36%",
				"var": "@_black36",
				"hex": "rgba(0,0,0,.36)"
			},
			{
				"name": "Black 38%",
				"var": "@_black38",
				"hex": "rgba(0,0,0,.38)"
			},
			{
				"name": "Black 54%",
				"var": "@_black54",
				"hex": "rgba(0,0,0,.54)"
			},
			{
				"name": "Black 87%",
				"var": "@_black87",
				"hex": "rgba(0,0,0,.87)"
			}
		]
	},
	{
		"category": "Lead",
		"colors": [
			{
				"name": "Lead Aqua",
				"var": "@_aqua",
				"hex": "#28bbbb"
			},
			{
				"name": "Lead Aqua Bright",
				"var": "@_aquaBright",
				"hex": "#76DDDD"
			},
			{
				"name": "Lead Aqua Dark",
				"var": "@_aquaDark",
				"hex": "#28AAAA"
			},
			{
				"name": "Lead purple",
				"var": "@leadPurple",
				"hex": "#B627A1"
			},
			{
				"name": "Lead grey",
				"var": "@_leadGrey",
				"hex": "#4C4D4F"
			},
			{
				"name": "White",
				"var": "@white",
				"hex": "#FFFFFF"
			},
			{
				"name": "Black",
				"var": "@black",
				"hex": "#000000"
			}
		]
	},
	{
		"category": "Whites",
		"colors": [
			{
				"name": "White 87%",
				"var": "@_white87",
				"hex": "rgba(255,255,255,.87)"
			}
		]
	},
	{
		"category": "Aquas",
		"colors": [
			{
				"name": "Aqua 12%",
				"var": "@_aqua12",
				"hex": "rgba(40,187,187,.12)"
			},
			{
				"name": "Aqua 30%",
				"var": "@aqua30",
				"hex": "#68CFCF"
			}
		]
	},
	{
		"category": "Supporting Highlight",
		"colors": [
			{
				"name": "Mint",
				"var": "@_mint",
				"hex": "#00CA9B"
			},
			{
				"name": "Lead Aqua Light",
				"var": "@_aquaLight",
				"hex": "#C4F4F4"
			},
			{
				"name": "Lead grey",
				"var": "@_leadGrey",
				"hex": "#4C4D4F"
			},
			{
				"name": "Highlight Yellow",
				"var": "@_yellow",
				"hex": "#FFBC45"
			},
			{
				"name": "Highlight Orange",
				"var": "@_orange",
				"hex": "#FF6221"
			},
			{
				"name": "Highlight Grey",
				"var": "@_grey",
				"hex": "#949494"
			}
		]
	},
	{
		"category": "Supporting Background",
		"colors": [
			{
				"name": "Bg Green",
				"var": "@_mintLight",
				"hex": "#CCF4EB"
			},
			{
				"name": "Bg Purple",
				"var": "@_purpleLight",
				"hex": "#F0D4EC"
			},
			{
				"name": "Bg Yellow",
				"var": "@_yellowLight",
				"hex": "#FFF2DA"
			},
			{
				"name": "Bg Orange",
				"var": "@_orangeLight",
				"hex": "#FFDDCC"
			},
			{
				"name": "Bg Grey",
				"var": "@_greyLight",
				"hex": "#EAEAEA"
			}
		]
	},
	{
		"category": "Text",
		"colors": [
			{
				"name": "Link",
				"var": "@blueSapphire",
				"hex": "#003DB5"
			},
			{
				"name": "Link Visisted",
				"var": "@purpleDark",
				"hex": "#9C218A"
			},
			{
				"name": "Matching Text",
				"var": "@magentaDark",
				"hex": "#A61F44"
			},
			{
				"name": "Lead Text",
				"var": "@grey91",
				"hex": "#181818"
			},
			{
				"name": "Secondary Text",
				"var": "@grey65",
				"hex": "#595959"
			},
			{
				"name": "Disabled Text",
				"var": "@grey42",
				"hex": "#949494"
			},
			{
				"name": "Alert Text",
				"var": "@trueBlood",
				"hex": "#D0021D"
			}
		]
	},
	{
		"category": "Sentiment",
		"colors": [
			{
				"name": "Negative",
				"var": "@redCarmine",
				"hex": "#B54239"
			},
			{
				"name": "Positive",
				"var": "@greenApple",
				"hex": "#6AAB50"
			}
		]
	},
	{
		"category": "Chart - Basic",
		"colors": [
			{
				"name": "Blue Bright",
				"var": "@blueBright",
				"hex": "#3399FF"
			},
			{
				"name": "Blue Deep",
				"var": "@blueDeep",
				"hex": "#0071E5"
			},
			{
				"name": "Lime",
				"var": "@greenLime",
				"hex": "#75B000"
			},
			{
				"name": "Green Leaf",
				"var": "@greenLeaf",
				"hex": "#598600"
			},
			{
				"name": "Yellow Gold",
				"var": "@yellowGold",
				"hex": "#FFAD00"
			},
			{
				"name": "Purple",
				"var": "@purple",
				"hex": "#684CDB"
			},
			{
				"name": "Violet",
				"var": "@violet",
				"hex": "#4424AD"
			},
			{
				"name": "Lilac",
				"var": "@lilac",
				"hex": "#A776A4"
			},
			{
				"name": "Plum",
				"var": "@plum",
				"hex": "#8B3B86"
			},
			{
				"name": "Blue Astral",
				"var": "@blueAstral",
				"hex": "#3470A3"
			},
			{
				"name": "Blumine",
				"var": "@blumine",
				"hex": "#1D5587"
			},
			{
				"name": "Aqua Light",
				"var": "@aquaLight",
				"hex": "#70D5DD"
			},
			{
				"name": "Aqua",
				"var": "@aqua",
				"hex": "#34B7BD"
			},
			{
				"name": "Blue Chill",
				"var": "@blueGreen",
				"hex": "#0D959B"
			},
			{
				"name": "Blue Malibu",
				"var": "@blueMalibu",
				"hex": "#59B4F5"
			},
			{
				"name": "Blue Sky",
				"var": "@blueSky",
				"hex": "#2E8ED3"
			}
		]
	},
	{
		"category": "Chart - Vibrant",
		"colors": [
			{
				"name": "Cyan",
				"var": "@blueCurious",
				"hex": "#2A97D6"
			},
			{
				"name": "Orange",
				"var": "@carrot",
				"hex": "#FF9900"
			},
			{
				"name": "Rose",
				"var": "@rose",
				"hex": "#FF7191"
			},
			{
				"name": "GreenAcid",
				"var": "@greenAcid",
				"hex": "#BDBD00"
			},
			{
				"name": "Mango",
				"var": "@mango",
				"hex": "#FFCB00"
			},
			{
				"name": "DeepMagenta",
				"var": "@deepMagenta",
				"hex": "#ED51ED"
			},
			{
				"name": "Turquoise",
				"var": "@turquoise",
				"hex": "#00ECD1"
			},
			{
				"name": "Mustard",
				"var": "@mustard",
				"hex": "#D1A921"
			},
			{
				"name": "Lavender",
				"var": "@lavender",
				"hex": "#C56DFF"
			},
			{
				"name": "Peach",
				"var": "@peach",
				"hex": "#F2AD6E"
			}
		]
	},
	{
		"category": "Chart - Dark",
		"colors": [
			{
				"name": "Blue",
				"var": "@blueYale",
				"hex": "#11469F"
			},
			{
				"name": "Magenta",
				"var": "@fandango",
				"hex": "#B23B8C"
			},
			{
				"name": "Purple",
				"var": "@purpleRoyal",
				"hex": "#7A3A9E"
			},
			{
				"name": "BlueStone",
				"var": "@blueStone",
				"hex": "#006363"
			},
			{
				"name": "GreenArmy",
				"var": "@greenArmy",
				"hex": "#4B5E00"
			}
		]
	},
	{
		"category": "MW 1.0",
		"colors": [
			{
				"name": "White Grey 3%",
				"var": "@grey3",
				"source": "lighten(@black, 97%)",
				"hex": "#F7F7F7"
			},
			{
				"name": "White Grey 5%",
				"var": "@grey5",
				"source": "lighten(@black, 95%)",
				"hex": "#F2F2F2"
			},
			{
				"name": "Light Grey 8%",
				"var": "@grey8",
				"source": "lighten(@black, 92%)",
				"hex": "#EBEBEB"
			},
			{
				"name": "Light Grey 10%",
				"var": "@grey10",
				"source": "lighten(@black, 90%)",
				"hex": "#E6E6E6"
			},
			{
				"name": "Mid Grey 20%",
				"var": "@grey20",
				"source": "lighten(@black, 80%)",
				"hex": "#CCCCCC"
			},
			{
				"name": "Grey 50%",
				"var": "@grey50",
				"source": "lighten(@black, 50%)",
				"hex": "#808080"
			},
			{
				"name": "Grey 80%",
				"var": "@grey80",
				"source": "lighten(@black, 20%)",
				"hex": "#333333"
			},
			{
				"name": "Grey 85%",
				"var": "@grey85",
				"source": "lighten(@black, 15%)",
				"hex": "#262626"
			},
			{
				"name": "Dark Grey 91%",
				"var": "@grey91",
				"source": "lighten(@black,  9%)",
				"hex": "#181818"
			},
			{
				"name": "Grey Blue 100%",
				"var": "@greyBlue",
				"hex": "#1A3B56"
			},
			{
				"name": "Grey Blue 80%",
				"var": "@greyBlue80",
				"source": "multiply(fade(@greyBlue, 80%), @white)",
				"hex": "#486278"
			},
			{
				"name": "Grey Blue 60%",
				"var": "@greyBlue60",
				"source": "multiply(fade(@greyBlue, 60%), @white)",
				"hex": "#76899A"
			},
			{
				"name": "Grey Blue 40%",
				"var": "@greyBlue40",
				"source": "multiply(fade(@greyBlue, 40%), @white)",
				"hex": "#A3B1BB"
			},
			{
				"name": "Grey Blue 20%",
				"var": "@greyBlue20",
				"source": "multiply(fade(@greyBlue, 20%), @white)",
				"hex": "#D1D8DD"
			},
			{
				"name": "Grey Blue 10%",
				"var": "@greyBlue10",
				"source": "multiply(fade(@greyBlue, 10%), @white)",
				"hex": "#E8E8E8"
			},
			{
				"name": "Grey Blue 5%",
				"var": "@greyBlue5",
				"source": "multiply(fade(@greyBlue,  5%), @white)",
				"hex": "#F4F5F7"
			},
			{
				"name": "Light Blue",
				"var": "@blueLight",
				"hex": "#99CCFF"
			},
			{
				"name": "Bright Blue",
				"var": "@blueBright",
				"hex": "#3399FF"
			},
			{
				"name": "Steel Blue",
				"var": "@blueSteel",
				"hex": "#6699CC"
			},
			{
				"name": "Crayon Blue",
				"var": "@blueCrayon",
				"hex": "#005FFF"
			},
			{
				"name": "Dark Blue",
				"var": "@blueDark",
				"hex": "#006699"
			},
			{
				"name": "Light Green",
				"var": "@greenLight",
				"hex": "#CCFF99"
			},
			{
				"name": "Green",
				"var": "@green",
				"hex": "#99CC33"
			},
			{
				"name": "Dark Green",
				"var": "@greenDark",
				"hex": "#336600"
			},
			{
				"name": "Light Yellow",
				"var": "@yellowLight",
				"hex": "#FFECBE"
			},
			{
				"name": "ellow",
				"var": "@yellow",
				"hex": "#FFCE55"
			},
			{
				"name": "Dark Yellow",
				"var": "@yellowDark",
				"hex": "#F39F2E"
			},
			{
				"name": "/Light Red",
				"var": "@redLight",
				"hex": "#FFCCCC"
			},
			{
				"name": "Red",
				"var": "@red",
				"hex": "#cc3333"
			},
			{
				"name": "Dark Red",
				"var": "@redDark",
				"hex": "#990000"
			},
			{
				"name": "Magenta",
				"var": "@magenta",
				"hex": "#FD005A"
			}
		]
	},
	{
		"category": "Additional",
		"colors": [
			{
				"name": "blueTwitter",
				"var": "@blueTwitter",
				"hex": "#55acee"
			},
			{
				"name": "blueFacebook",
				"var": "@blueFacebook",
				"hex": "#3c5b9a"
			},
			{
				"name": "redYouTube",
				"var": "@redYouTube",
				"hex": "#cd201f"
			},
			{
				"name": "blueInstagram",
				"var": "@blueInstagram",
				"hex": "#6a8baa"
			},
			{
				"name": "orangeBlogger",
				"var": "@orangeBlogger",
				"hex": "#f79238"
			},
			{
				"name": "orange",
				"var": "@orange",
				"hex": "#FF3800"
			},
			{
				"name": "greyOrange",
				"var": "@greyOrange",
				"hex": "#93826A"
			},
			{
				"name": "whiteGrey",
				"var": "@whiteGrey",
				"hex": "#f1f1f1"
			},
			{
				"name": "darkGrey",
				"var": "@darkGrey",
				"hex": "#555555"
			},
			{
				"name": "grayLight",
				"var": "@grayLight",
				"hex": "#808080"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/lib/shared/colors.json
// module id = 467
// module chunks = 0